import NumberFormatter from '../number'
import Store from '../../store'

const format = function (value, decimals = 2) {
  let currency = Store.getters.currency
  value = NumberFormatter.format(value, decimals)
  if (currency) {
    switch (currency.position) {
      case 'before':
        return currency.token + value
      case 'after':
        return value + currency.token
    }
  }
  return value
}

export default {
  format: format
}



// WEBPACK FOOTER //
// ./src/filters/currency/index.js